import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { Section, H2, P, DataField } from "./common-components";
import { AllergicRhinitisDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const EducationalInformation = () => {
  const { treatment, formType } = useContext(FormContextMA);
  const anyPrescriptions = !!(
    treatment?.nasalSalineRinsePrescriptions?.length ||
    treatment?.nasalSalineSprayPrescriptions?.length ||
    treatment?.nasalLubricantPrescriptions?.length ||
    treatment?.firstLineTherapyPrescriptions?.length ||
    treatment?.stepUpTherapyPrescriptions?.length ||
    treatment?.alternativeFirstLineTherapyPrescriptions?.length ||
    treatment?.addOnTherapyOralDecongestantsPrescriptions?.length ||
    treatment?.addOnTherapyIntranasalDecongestantsPrescriptions?.length ||
    treatment?.addOnTherapyOralAntihistaminesPrescriptions?.length
  );

  return anyPrescriptions ? (
    <Section className="space-y-[0.0833333in]">
      <H2>Educational Information</H2>
      <DataField
        label={"Education has been provided for each prescription issued."}
      />
      <DataField
        label={
          formType === AllergicRhinitisDocTypes.InitialAssessment
            ? <>A Storyboard has been provided to the patient as a take away for additional education about the Minor Ailment, <br/> including instructions how to use the medication, how to assess for benefits, and how to manage side effects.</>
            : <>Storyboard provided to the patient as a take away for additional education including instructions for medications, assess for benefits, and manage side effects, if applicable.</>
        }
      />
    </Section>
  ) : null;
};
